import React from 'react';
import { format } from 'date-fns';
import { EventGroupFormatsEnum } from 'types/generated/client';
import { getEventSchedule } from 'utils/shared/time/getEventSchedule';
import VictoryCupShadow from 'svg/VictoryCupShadow';
import { Button } from 'components/Button';
import Countdown from 'components/Countdown';
import { EventProps } from '../types';

interface Props extends EventProps {
  onGoBack: () => void;
}

export default function GamedayCountdown({ event, onGoBack }: Props) {
  const startDateTime = event.startDateTime
    ? new Date(getEventSchedule(event).current.startsAt)
    : null;

  const formattedStartTime = startDateTime
    ? format(startDateTime, "h:mm a 'on' EEEE MMMM d")
    : null;

  const isVairEvent =
    event.isVairRequired ||
    event.groups?.some((g) => g.format === EventGroupFormatsEnum.VairRoundRobin);

  return (
    <div className="flex flex-col items-center gap-6 rounded-3xl bg-color-bg-darkmode-primary p-6 shadow-[0px_4px_16px_0px_rgba(0,0,0,0.08)]">
      <VictoryCupShadow className="h-[10.6rem] w-[10.6rem]" />

      <div className="flex flex-col items-center gap-2 text-center">
        <p className="typography-product-heading-mobile text-color-text-darkmode-primary">
          Scheduled start time
        </p>
        {formattedStartTime && (
          <p className="typography-product-body text-color-text-darkmode-secondary">
            {formattedStartTime}
          </p>
        )}
      </div>

      {isVairEvent && (
        <img
          src="/images/vair/vair-transparent.png"
          alt="VAIR"
          className="h-8 w-auto object-contain"
        />
      )}

      {startDateTime && <Countdown date={startDateTime} />}

      <p className="typography-product-body text-color-text-darkmode-secondary">
        The tournament has not started yet.
      </p>

      <Button variant="brand" size="lg" onClick={onGoBack} className="w-full">
        Go back
      </Button>
    </div>
  );
}
